export default "__VITE_ASSET__JNxKjegM__"